const SELECT_FUNCTION = 'select';

export function findInputElement(basisElement: HTMLElement, noCheckbox = false): HTMLElement {
  let element: HTMLElement;
  // let element: HTMLElement = basisElement;
  if (basisElement && basisElement.tagName !== 'input' && basisElement.tagName !== 'textarea') {
    // wenn das Element KEIN input element ist
    // dann versuche ein input Element für dieses Element zu finden
    let inputElementHtmlCollection: HTMLCollectionOf<Element> = basisElement.getElementsByTagName('input');

    for (let i = 0; i < inputElementHtmlCollection.length; i++) {
      const currentElement: HTMLInputElement = inputElementHtmlCollection.item(i) as HTMLInputElement;
      if (!noCheckbox || (noCheckbox && currentElement.type !== 'checkbox')) {
        element = currentElement;
        break;
      }
    }

    if (!element) {
      // kein input element gefunden ->  versuche jetzt textarea zu finden
      inputElementHtmlCollection = basisElement.getElementsByTagName('textarea');
      if (inputElementHtmlCollection.length > 0) {
        element = <HTMLElement>inputElementHtmlCollection.item(0);
      } else {
        // kein input element gefunden ->  versuche jetzt select zu finden
        inputElementHtmlCollection = basisElement.getElementsByTagName('mat-select');
        if (inputElementHtmlCollection.length > 0) {
          element = <HTMLElement>inputElementHtmlCollection.item(0);
        }
      }
    }
  } else {
    element = basisElement;
  }
  return element;
}

export function setFocus(basisElement: HTMLElement | HTMLInputElement, select = true, noCheckbox = false) {
  try {
    const element = findInputElement(basisElement, noCheckbox);

    if (element) {
      element.focus();
      if (select && element[SELECT_FUNCTION] && typeof element[SELECT_FUNCTION] === 'function') {
        element[SELECT_FUNCTION]();
      }
    }
  } catch (e) {
    console.error('setFocus', basisElement, e);
  }
}
